import type { Actor } from '@avatar/types';
import {
  ActorVariant,
  StudioProjectVersion,
} from '../../../../../server/graphql/__generated.types';
import { VariantWithVersion, getAvatarSwapValidationContext } from './swap';

/**
 * Different avatar handler api for modal
 * @todo should consolidate this with the universal avatar swap
 */
export interface HandleAvatarSwapParams {
  editor?: {
    hasCues?: boolean;
    hasReplacements?: boolean;
  };
  onAvatarWarning: (info: {
    selectedActor: Actor;
    variant: ActorVariant | undefined;
    variantVersion: string | undefined;
    lostFeatures: {
      cues?: boolean;
      replacements?: boolean;
    };
  }) => void;
  fromAvatar: VariantWithVersion;
  toAvatar: VariantWithVersion;
  selectedActor: Actor;
  variant: ActorVariant | undefined;
  onClose?: () => void;
  handleChangeAvatar: (
    newAvatar: Actor,
    location: 'list' | 'modal',
    newAvatarVariant?: ActorVariant,
    newAvatarVariantVersion?: string,
    swapContext?: {
      lostFeatures?: {
        cues?: boolean;
        replacements?: boolean;
      };
    }
  ) => void;
  studioVersion: StudioProjectVersion;
}

export const handleAvatarSwap = ({
  fromAvatar,
  toAvatar,
  selectedActor,
  variant,
  onClose,
  handleChangeAvatar,
  editor,
  onAvatarWarning,
}: HandleAvatarSwapParams) => {
  // validate avatar swap
  const validationContext = getAvatarSwapValidationContext(
    fromAvatar,
    toAvatar,
    editor
  );
  if (validationContext.canImmediatelySwap) {
    handleChangeAvatar(
      selectedActor,
      'modal',
      variant,
      toAvatar.variantVersion,
      {
        lostFeatures: validationContext.lostFeatures,
      }
    );
    onClose?.();
    return;
  }
  onAvatarWarning({
    selectedActor,
    variant,
    variantVersion: toAvatar.variantVersion,
    lostFeatures: validationContext.lostFeatures,
  });
};
